module.exports = __webpack_public_path__ + "static/img/zentec.60ac579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zentec.png
// module id = /NkH
// module chunks = 1